/**
 * @generated SignedSource<<003f6376cdd4e91c21a3c71616f0af7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MediaItemStatusEnum = "AUTO_DRAFT" | "INHERIT" | "PRIVATE" | "TRASH";
export type MimeTypeEnum = "APPLICATION_JAVA" | "APPLICATION_MSWORD" | "APPLICATION_OCTET_STREAM" | "APPLICATION_ONENOTE" | "APPLICATION_OXPS" | "APPLICATION_PDF" | "APPLICATION_RAR" | "APPLICATION_RTF" | "APPLICATION_TTAF_XML" | "APPLICATION_VND_APPLE_KEYNOTE" | "APPLICATION_VND_APPLE_NUMBERS" | "APPLICATION_VND_APPLE_PAGES" | "APPLICATION_VND_MS_ACCESS" | "APPLICATION_VND_MS_EXCEL" | "APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT" | "APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_PROJECT" | "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12" | "APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_WRITE" | "APPLICATION_VND_MS_XPSDOCUMENT" | "APPLICATION_VND_OASIS_OPENDOCUMENT_CHART" | "APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE" | "APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA" | "APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS" | "APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION" | "APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET" | "APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE" | "APPLICATION_WORDPERFECT" | "APPLICATION_X_7Z_COMPRESSED" | "APPLICATION_X_GZIP" | "APPLICATION_X_TAR" | "APPLICATION_ZIP" | "AUDIO_AAC" | "AUDIO_FLAC" | "AUDIO_MIDI" | "AUDIO_MPEG" | "AUDIO_OGG" | "AUDIO_WAV" | "AUDIO_X_MATROSKA" | "AUDIO_X_MS_WAX" | "AUDIO_X_MS_WMA" | "AUDIO_X_REALAUDIO" | "FONT_OTF" | "FONT_TTF" | "FONT_WOFF" | "FONT_WOFF2" | "IMAGE_AVIF" | "IMAGE_BMP" | "IMAGE_GIF" | "IMAGE_HEIC" | "IMAGE_HEIC_SEQUENCE" | "IMAGE_HEIF" | "IMAGE_HEIF_SEQUENCE" | "IMAGE_JPEG" | "IMAGE_PNG" | "IMAGE_TIFF" | "IMAGE_WEBP" | "IMAGE_X_ICON" | "TEXT_CALENDAR" | "TEXT_CSS" | "TEXT_CSV" | "TEXT_PLAIN" | "TEXT_RICHTEXT" | "TEXT_TAB_SEPARATED_VALUES" | "TEXT_VTT" | "VIDEO_3GPP" | "VIDEO_3GPP2" | "VIDEO_AVI" | "VIDEO_DIVX" | "VIDEO_MP4" | "VIDEO_MPEG" | "VIDEO_OGG" | "VIDEO_QUICKTIME" | "VIDEO_WEBM" | "VIDEO_X_FLV" | "VIDEO_X_MATROSKA" | "VIDEO_X_MS_ASF" | "VIDEO_X_MS_WM" | "VIDEO_X_MS_WMV" | "VIDEO_X_MS_WMX";
export type NewMediaItemInput = {
  altText?: string | null | undefined;
  authorId?: string | null | undefined;
  caption?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  commentStatus?: string | null | undefined;
  date?: string | null | undefined;
  dateGmt?: string | null | undefined;
  description?: string | null | undefined;
  file?: any | null | undefined;
  fileType?: MimeTypeEnum | null | undefined;
  parentId?: string | null | undefined;
  pingStatus?: string | null | undefined;
  slug?: string | null | undefined;
  status?: MediaItemStatusEnum | null | undefined;
  title?: string | null | undefined;
};
export type Media_CreateMediaItem_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: NewMediaItemInput;
};
export type Media_CreateMediaItem_Mutation$data = {
  readonly newMediaItem: {
    readonly mediaItem: {
      readonly __id: string;
      readonly author: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly description: string | null | undefined;
      readonly fileSize: number | null | undefined;
      readonly id: string;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Media_CreateMediaItem_Mutation = {
  response: Media_CreateMediaItem_Mutation$data;
  variables: Media_CreateMediaItem_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "mediaItem",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaItemUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mimeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaDetails",
      "kind": "LinkedField",
      "name": "mediaDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceUrl",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NodeWithAuthorToUserConnectionEdge",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Media_CreateMediaItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NewMediaItemPayload",
        "kind": "LinkedField",
        "name": "newMediaItem",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Media_CreateMediaItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NewMediaItemPayload",
        "kind": "LinkedField",
        "name": "newMediaItem",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "mediaItem",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "MediaItem"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d4237110ad62e50cc6de23e46c28f8c",
    "id": null,
    "metadata": {},
    "name": "Media_CreateMediaItem_Mutation",
    "operationKind": "mutation",
    "text": "mutation Media_CreateMediaItem_Mutation(\n  $input: NewMediaItemInput!\n) {\n  newMediaItem(input: $input) {\n    mediaItem {\n      id\n      mediaItemUrl\n      mimeType\n      mediaDetails {\n        sizes {\n          sourceUrl\n          name\n        }\n      }\n      description\n      title\n      fileSize\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a5078e064c1768b9bbb381f0bde9629";

export default node;
